import PrivatePageBanner from './PrivatePageBanner';

import './PrivatePageBanner.scss';

export default PrivatePageBanner;
